export default "__VITE_ASSET__5b6c8ed1__"